export default "__VITE_ASSET__Bt9A6mVr__"